import {
  InitiativeStatus,
  normalizeKeyInitiativeStatus,
} from 'partner360/entities/keyInitiatives/model/status'

import styles from '../ShortTermInitiatives.module.scss'

export const getStatusClass = (status?: string) => {
  switch (normalizeKeyInitiativeStatus(status)) {
    case InitiativeStatus.AtRisk:
      return styles.status__red
    case InitiativeStatus.OnTrack:
      return styles.status__yellow
    case InitiativeStatus.Done:
      return styles.status__green
    case InitiativeStatus.New:
      return styles.status__light_blue
    default:
      return undefined
  }
}
